// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2HDmS","box":"WorkspacesBox_box__1zyBh","node":"WorkspacesBox_node__3Qp1X"};